export const RESET = 'RESET';
export const RESET_PART = 'RESET_PART';
export const SET_JERSEY_VIEW = 'SET_JERSEY_VIEW';
export const SET_JERSEYS = 'SET_JERSEYS';
export const SET_LOADING = 'SET_LOADING';
export const SET_MORE = 'SET_MORE';
export const SET_NUMBERS = 'SET_NUMBERS';
export const SET_PAGE = 'SET_PAGE';
export const SET_SORT = 'SET_SORT';
export const SET_TOTAL = 'SET_TOTAL';
export const SET_TRACK = 'SET_TRACK';
export const SET_VISIBILITY_MODAL = 'SET_VISIBILITY_MODAL';

export default {
  RESET,
  RESET_PART,
  SET_JERSEY_VIEW,
  SET_JERSEYS,
  SET_LOADING,
  SET_MORE,
  SET_NUMBERS,
  SET_PAGE,
  SET_SORT,
  SET_TOTAL,
  SET_TRACK,
  SET_VISIBILITY_MODAL,
};
